<template>
  <div class="mt30">
    <div class="d-b-c">
    </div>
    <div class="">
      <div class="Echarts">
        <div id="user-age-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getAge, getGender} from '@/api/education';
  import {
    formatDate
  } from '@/utils/DateTime.js'
  export default {
      data() {
          let endDate = new Date();
          let startDate = new Date();
          startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
          return {
              /*是否正在加载*/
              loading: true,
              /*类别*/
              activeName: 'order',
              /*时间快捷选项*/
              pickerOptions: {
                  shortcuts: [{
                      text: '最近一周',
                      onClick(picker) {
                          const end = new Date();
                          const start = new Date();
                          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                          picker.$emit('pick', [start, end]);
                      }
                  },
                      {
                          text: '最近一个月',
                          onClick(picker) {
                              const end = new Date();
                              const start = new Date();
                              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                              picker.$emit('pick', [start, end]);
                          }
                      },
                      {
                          text: '最近三个月',
                          onClick(picker) {
                              const end = new Date();
                              const start = new Date();
                              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                              picker.$emit('pick', [start, end]);
                          }
                      }
                  ]
              },
              datePicker: [formatDate(startDate, 'yyyy-MM-dd'), formatDate(endDate, 'yyyy-MM-dd')],
              /*数据对象*/
              dataList: null,
              /*交易统计图表对象*/
              myChart: null,
              /*图表数据*/
              option: {
                  title: {
                      text: '年龄分布',
                      subtext: '年龄分布统计',
                      left: 'center'
                  },
                  legend: {
                      top: '15%',
                      left: 'center'
                  },
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'shadow'
                      },
                      formatter: function (params) {
                          return params[0].axisValue + '岁'
                      }
                  },
                  grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '3%',
                      containLabel: true
                  },
                  xAxis: {
                      type: 'category',
                      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                  },
                  yAxis: {
                      type: 'value'
                  },
                  series: [
                      {
                          data: [120, 200, 150, 80, 70, 110, 130],
                          type: 'bar',
                          showBackground: true,
                          backgroundStyle: {
                              color: 'rgba(180, 180, 180, 0.2)'
                          },
                          itemStyle: {
                              normal: {
                                  //这里是颜色
                                  color: function(params) {
                                      //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                                      var colorList = ['#00A3E0','#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0','#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0'];
                                      return colorList[params.dataIndex]
                                  }
                              }
                          }
                      }
                  ]
              },

          };
      },
      created() {

      },
      mounted() {
          this.myEcharts();
      },
      methods: {

          /*切换*/
          handleClick(e) {
              this.getData();
          },

          /*选择时间*/
          changeDate() {
              this.getData();
          },

          /*创建图表对象*/
          myEcharts() {
              // 基于准备好的dom，初始化echarts实例
              this.myChart = this.$echarts.init(document.getElementById('user-age-line'));
              /*获取列表*/
              this.getData();
          },

          /*格式数据*/
          createOption() {
              let series = [
                  {
                      data: this.dataList.age_count,
                      type: 'bar',
                      showBackground: true,
                      backgroundStyle: {
                          color: 'rgba(180, 180, 180, 0.2)'
                      },
                      itemStyle: {
                          normal: {
                              //这里是颜色
                              color: function(params) {
                                  //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                                  var colorList = ['#00A3E0','#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0','#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0', '#00A3E0'];
                                  return colorList[params.dataIndex]
                              }
                          }
                      }
                  }
              ]
              this.option.series = series
              this.option.xAxis.data = this.dataList.age_region
              this.myChart.setOption(this.option);
              this.myChart.resize();
          },

          /*获取列表*/
          getData() {
              let self = this;
              self.loading = true;
              getAge({}).then(res => {
                  self.dataList = res.data;
                  self.loading = false;
                  console.log(res)
                  self.createOption();
              }).catch(error => {});
          },
      },
  };
</script>

<style>
  .Echarts {
    box-sizing: border-box;
  }

  .Echarts>div {
    width: 100%;
    height: 400px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/part/user-age-line.vue